var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"home"}},[(_vm.dataFetched)?_c('router-view',{attrs:{"dataFetched":_vm.dataFetched,"cssLoaded":_vm.cssLoaded}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }